import React from 'react';
import styled from 'styled-components';
import { formatters } from '../services/api';

import { LuUsers, LuDollarSign, LuCircleCheck, LuClock } from 'react-icons/lu';

const SummaryContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const SummaryCard = styled.div`
  background: ${props => props.theme.colors.white};
  border-radius: 12px;
  padding: 25px;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid #e2e8f0;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  @media (max-width: 768px) {
    flex-direction: row;
    padding: 15px 20px;
    text-align: left;
    align-items: center;
  }
`;

const SummaryCardIcon = styled.div`
  font-size: 28px;
  margin-bottom: 12px;
  color: ${props => props.color || props.theme.colors.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background: ${props => props.bgColor || props.theme.colors.lightBlue};
  border-radius: 12px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    margin-bottom: 0;
    margin-right: 15px;
    width: 44px;
    height: 44px;
    font-size: 24px;
  }
`;

const SummaryCardText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 768px) {
    align-items: flex-start;
  }
`;

const SummaryCardValue = styled.div`
  font-size: 32px;
  font-weight: 700;
  color: ${props => props.theme.colors.primary};
  margin-bottom: 5px;

  @media (max-width: 768px) {
    font-size: 22px;
    margin-bottom: 0;
  }
`;

const SummaryCardLabel = styled.div`
  font-size: 14px;
  color: ${props => props.theme.colors.grayMedium};
  font-weight: 500;

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

const SummaryCards = ({ resumo, currentMonthValue }) => {
  if (!resumo) return null;

  return (
    <SummaryContainer>
      <SummaryCard>
        <SummaryCardIcon color="#1e3a8a" bgColor="#dbeafe">
          <LuUsers />
        </SummaryCardIcon>
        <SummaryCardText>
          <SummaryCardValue>{resumo.totalDependentes || 0}</SummaryCardValue>
          <SummaryCardLabel>Total de Dependentes</SummaryCardLabel>
        </SummaryCardText>
      </SummaryCard>
      
      <SummaryCard>
        <SummaryCardIcon color="#10b981" bgColor="#dcfce7">
          <LuDollarSign />
        </SummaryCardIcon>
        <SummaryCardText>
          <SummaryCardValue>{formatters.formatCurrency(currentMonthValue ?? resumo.valorTotalMensal)}</SummaryCardValue>
          <SummaryCardLabel>Valor Total Mensal</SummaryCardLabel>
        </SummaryCardText>
      </SummaryCard>
      
      <SummaryCard>
        <SummaryCardIcon color="#3b82f6" bgColor="#eff6ff">
          <LuCircleCheck />
        </SummaryCardIcon>
        <SummaryCardText>
          <SummaryCardValue>{resumo.pagamentosPagos || 0}</SummaryCardValue>
          <SummaryCardLabel>Pagamentos em Dia</SummaryCardLabel>
        </SummaryCardText>
      </SummaryCard>
      
      <SummaryCard>
        <SummaryCardIcon color="#f59e0b" bgColor="#fef3c7">
          <LuClock />
        </SummaryCardIcon>
        <SummaryCardText>
          <SummaryCardValue>{resumo.pagamentosAVencer || 0}</SummaryCardValue>
          <SummaryCardLabel>Pagamentos a Vencer</SummaryCardLabel>
        </SummaryCardText>
      </SummaryCard>
    </SummaryContainer>
  );
};

export default SummaryCards;


